<template>
  <v-container fluid grid-list-xl>
    <v-layout wrap align-center>
    <v-flex v-if="displaySettings">
      <v-flex xs12 ma-4>
      <div class="text-center subheading font-weight-regular grey--text text--darken-1">Language</div>
        <v-switch
            v-model="overrideSiteDetection"
            color="red"
            :label="`Override site detection: ${overrideSiteDetection.toString()}`"
            @change="setSettings"
        ></v-switch>
      </v-flex>

      <v-flex xs6 sm6 d-flex>
      <v-select
        :items="countryCodes"
        label="Country code"
        placeholder="Select one"
        v-model="countryCodeSelected"
        @input="setCountry"
        :disabled="!overrideSiteDetection"
        color="red"></v-select>
      </v-flex>
      <v-flex xs6 sm6>
      <v-select
        :items="localeCodes"
        label="Locale"
        placeholder="Select one"
        v-model="localeCodeSelected"
        @input="setLocale"
        :disabled="!overrideSiteDetection"
      >
      </v-select>
      </v-flex>
    </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Settings",
  data() {
    return {
      overrideSiteDetection: false,
      displaySettings: true,
      countryCodes: ['FR', 'UK', 'US', 'DE', 'IT', 'ESP', 'JP', 'KO', 'SA', 'SE', 'RU', 'KO', 'NL', 'TH'],
      localeCodes: ['fr', 'en', 'de', 'it', 'es', 'ja', 'ko', 'ar', 'pt', 'sv', 'ru', 'ko', 'nl', 'th'],
      countryCodeSelected: 'UK',
      localeCodeSelected: 'en'
    }
  },
  props: {
    locale: {
      type: String,
      default: () => 'en'
    },
    country: {
      type: String,
      default: () => 'UK'
    },
  },
  created() {
    this.localeCodeSelected = JSON.parse(localStorage.getItem('langSET'))
    this.countryCodeSelected = JSON.parse(localStorage.getItem('countrySET'))
    if (JSON.parse(localStorage.getItem('settingsPFO'))===true) {
      this.overrideSiteDetection = "true"
      this.localeCodeSelected = JSON.parse(localStorage.getItem('langSET'))
      this.countryCodeSelected = JSON.parse(localStorage.getItem('countrySET'))
    }
  },
  watch: {
    currentLocale () {
    }
  },
  methods: {
    setSettings(setting) {
      localStorage.setItem('settingsPFO', JSON.stringify(setting))
      this.overrideSiteDetection = setting
    },
    setCountry(countryCode) {
      localStorage.setItem('countryPFO', JSON.stringify(countryCode))
      localStorage.setItem('countrySET', JSON.stringify(countryCode))
      this.countryCodeSelected = countryCode
    },
    setLocale(localeCode) {
      localStorage.setItem('langPFO', JSON.stringify(localeCode))
      localStorage.setItem('langSET', JSON.stringify(localeCode))
      this.localeCodeSelected = localeCode
    }
  }
}
</script>

<style scoped>

</style>